export default async () => {
  window.addEventListener("availableImagesBuilt", async()=> {
    await window.appInitializer.initResidenceGalerryApp();
  })
}